/* eslint-disable max-len */
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@mui/styles'
import {
  Container,
  Dialog,
  IconButton,
  Toolbar,
  useMediaQuery,
} from '@mui/material'
import { ArrowBack, ArrowForward, Close } from '@mui/icons-material'
import getQueryStringValue from '../lib/getQueryStringValue'
import Summary from '../components/PayJourney/Summary'
import ChoosePlatform from '../components/PayJourney/ChoosePlatform'
import CollectEmail from '../components/PayJourney/CollectEmail'
import Checkout from '../components/PayJourney/Checkout'
import Finished from '../components/PayJourney/Finished'
import { PROVIDER, SERVER_URI } from '../consts'
import { PayData } from '../@types'
import { validateAndSanitizeEmail } from '../functions'
import SelectLanguage from '../components/SelectLanguage'

const useStyles = makeStyles(() => ({
  bg: {
    height: '100%',
    backgroundColor: '#ffffff',
    // eslint-disable-next-line quotes
    backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3Crect stroke='%23ffffff' stroke-width='.5' width='1' height='1' id='s'/%3E%3Cpattern id='a' width='3' height='3' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cuse fill='%23fcfcfc' href='%23s' y='2'/%3E%3Cuse fill='%23fcfcfc' href='%23s' x='1' y='2'/%3E%3Cuse fill='%23fafafa' href='%23s' x='2' y='2'/%3E%3Cuse fill='%23fafafa' href='%23s'/%3E%3Cuse fill='%23f7f7f7' href='%23s' x='2'/%3E%3Cuse fill='%23f7f7f7' href='%23s' x='1' y='1'/%3E%3C/pattern%3E%3Cpattern id='b' width='7' height='11' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23f5f5f5'%3E%3Cuse href='%23s'/%3E%3Cuse href='%23s' y='5' /%3E%3Cuse href='%23s' x='1' y='10'/%3E%3Cuse href='%23s' x='2' y='1'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='8'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='5' y='2'/%3E%3Cuse href='%23s' x='5' y='6'/%3E%3Cuse href='%23s' x='6' y='9'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='h' width='5' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23f5f5f5'%3E%3Cuse href='%23s' y='5'/%3E%3Cuse href='%23s' y='8'/%3E%3Cuse href='%23s' x='1' y='1'/%3E%3Cuse href='%23s' x='1' y='9'/%3E%3Cuse href='%23s' x='1' y='12'/%3E%3Cuse href='%23s' x='2'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='2'/%3E%3Cuse href='%23s' x='3' y='6'/%3E%3Cuse href='%23s' x='3' y='11'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='4' y='10'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='c' width='17' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23f2f2f2'%3E%3Cuse href='%23s' y='11'/%3E%3Cuse href='%23s' x='2' y='9'/%3E%3Cuse href='%23s' x='5' y='12'/%3E%3Cuse href='%23s' x='9' y='4'/%3E%3Cuse href='%23s' x='12' y='1'/%3E%3Cuse href='%23s' x='16' y='6'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='d' width='19' height='17' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23ffffff'%3E%3Cuse href='%23s' y='9'/%3E%3Cuse href='%23s' x='16' y='5'/%3E%3Cuse href='%23s' x='14' y='2'/%3E%3Cuse href='%23s' x='11' y='11'/%3E%3Cuse href='%23s' x='6' y='14'/%3E%3C/g%3E%3Cg fill='%23efefef'%3E%3Cuse href='%23s' x='3' y='13'/%3E%3Cuse href='%23s' x='9' y='7'/%3E%3Cuse href='%23s' x='13' y='10'/%3E%3Cuse href='%23s' x='15' y='4'/%3E%3Cuse href='%23s' x='18' y='1'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='e' width='47' height='53' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23F60'%3E%3Cuse href='%23s' x='2' y='5'/%3E%3Cuse href='%23s' x='16' y='38'/%3E%3Cuse href='%23s' x='46' y='42'/%3E%3Cuse href='%23s' x='29' y='20'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='f' width='59' height='71' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23F60'%3E%3Cuse href='%23s' x='33' y='13'/%3E%3Cuse href='%23s' x='27' y='54'/%3E%3Cuse href='%23s' x='55' y='55'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='g' width='139' height='97' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23F60'%3E%3Cuse href='%23s' x='11' y='8'/%3E%3Cuse href='%23s' x='51' y='13'/%3E%3Cuse href='%23s' x='17' y='73'/%3E%3Cuse href='%23s' x='99' y='57'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23b)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23h)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23c)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23d)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23e)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23f)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23g)' width='100%25' height='100%25'/%3E%3C/svg%3E\")",
    backgroundAttachment: 'fixed',
    backgroundSize: 'cover',
    position: 'relative',
  },
  dialog: {
    width: 445,
    height: 745,
  },
  appBar: {
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
  },
  logoContainer: {
    flex: 1,
    textAlign: 'center',
    letterSpacing: '1.5px',
    fontSize: 24,
    fontWeight: 'bold',
    userSelect: 'none',
  },
  icon: {
    '& svg': {
      width: 25,
      height: 25,
    },
  },
  container: {
    minWidth: 400,
    height: 'calc(100% - 100px)',
    display: 'flex !important',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
}), { name: 'Pay' })

const EmptyDiv = (): JSX.Element => <div style={{ width: '4rem' }} />

const Pay = (props: React.PropsWithChildren<unknown>): JSX.Element => {
  const { t } = useTranslation()
  const classes = useStyles(props)
  const isMobile = useMediaQuery('(max-width: 550px)')
  const token = getQueryStringValue('token')
  const paymentId = getQueryStringValue('paymentId')
  
  const [step, setStep] = useState(0)
  const [loading, setLoading] = useState(false)
  const [paymentData, setPaymentData] = useState<PayData | null>(null)
  const [paymentProvider, setPaymentProivder] = useState('')
  const [isSuccess, setIsSuccess] = useState<boolean>(false)

  const getPaymentData = async (): Promise<void> => {
    setLoading(true)
    try {
      const { payment } = await (await fetch(`${SERVER_URI}/payment/${paymentId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })).json()
      
      if (payment) setPaymentData(payment)
    } catch (error) {
      console.error(error)
    }
    setLoading(false)
  }

  const updateEmail = async (email: string): Promise<void> => {
    setLoading(true)
    const validatedEmail = validateAndSanitizeEmail(email)

    if (validatedEmail) {
      if (validatedEmail !== paymentData?.receiptEmail) {   
        try {  
          await fetch(`${SERVER_URI}/payment/${paymentId}`, {
            method: 'PATCH',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              receiptEmail: validatedEmail,
            }),
          })
        
          await getPaymentData()
        } catch (error) {
          console.error(error)
          setLoading(false)
          throw new Error(t('An error occurred when updating the information, please try again'))
        }
      } else {
        setLoading(false)
      }
    } else {
      setLoading(false)
      throw new Error(t('Email is invalid!'))
    }
  }

  useEffect(() => {
    if (paymentId) getPaymentData()
  }, [paymentId]) // eslint-disable-line

  const clickForward = (): void => {
    setStep((prev) => {
      if (prev === 4) {
        return prev
      }

      return prev + 1
    })
  }

  const clickBack = (): void => {
    setStep((prev) => {
      if (prev === 0) {
        return prev
      }
      
      return prev - 1
    })
  }

  const clickClose = (): void => {
    alert('not supported yet')
  }

  return (
    <Dialog open fullScreen={isMobile}>
      <div className={`${isMobile ? '' : classes.dialog} ${classes.bg}`}>
        <Toolbar className={classes.appBar}>
          {step === 0 ? (
            <EmptyDiv />
          ) : (step > 0 && step < 3) ? (
            <IconButton className={classes.icon} edge="start" color="inherit" onClick={clickBack} aria-label="close">
              {document.body.dir === 'ltr' ? <ArrowBack /> : <ArrowForward />}
            </IconButton>
          ) : <EmptyDiv />}

          <h1 className={classes.logoContainer}>
            {PROVIDER}
          </h1>
          
          {step === 0 ? (
            <SelectLanguage />
          ) : step > 0 ? (
            <IconButton className={classes.icon} edge="start" color="inherit" onClick={clickClose} aria-label="close">
              <Close />
            </IconButton>
          ) : <EmptyDiv />}
        </Toolbar>
        
        <Container component="main" maxWidth="xs" className={classes.container}>
          {step === 0 && (<Summary nextStep={clickForward} loading={loading} paymentData={paymentData} />)}
          {step === 1 && (<ChoosePlatform nextStep={clickForward} setPaymentProivder={setPaymentProivder} />)}
          {step === 2 && (<CollectEmail nextStep={clickForward} loading={loading} receiptEmail={paymentData?.receiptEmail ?? ''} updateEmail={updateEmail} />)}
          {step === 3 && (<Checkout nextStep={clickForward} paymentProvider={paymentProvider} paymentData={paymentData} setIsSuccess={setIsSuccess} />)}
          {step === 4 && (<Finished isSuccess={isSuccess} />)}
        </Container>
      </div>
    </Dialog>
  )
}

export default Pay
